import type SubjectFieldDraftView from '@UI/Store/SubjectTypeDefinitions/Views/SubjectFieldDraftView';
import isChoiceNature from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/Helpers/isChoiceNature';

const OPTION_COUNT_PHRASES: Readonly<Record<'one' | 'many', (count: number) => string>> = {
	one: () => '1 option',
	many: (count) => `${count} options`,
};

/** The nature and states of a field on one line, e.g. « Choix · 3 options · envoyé à l'IA » (shown in capitals). */
function describeField(field: SubjectFieldDraftView, natureLabel: string): string {
	const parts = [natureLabel];

	if (isChoiceNature(field.nature)) {
		parts.push(OPTION_COUNT_PHRASES[field.options.length === 1 ? 'one' : 'many'](field.options.length));
	}

	if (field.required) {
		parts.push('obligatoire');
	}

	if (field.sentToAi) {
		parts.push("envoyé à l'IA");
	}

	return parts.join(' · ');
}

export default describeField;
